import React, { useEffect, useLayoutEffect, useState } from "react";
// @ts-ignore
import { Caas } from "caas_sdk_web";
import axios from "axios";
import { UrlRequiredError } from "viem";

function MudrexURL({ paymentUrl }) {
  useEffect(() => {
    console.log(paymentUrl);
    window.addEventListener(
      "message",
      (event) => {
        if (event.data.event === "success") {
          console.log("here", event.data.params);
        }
      },
      false
    );
    console.log("url is ", paymentUrl);
  }, []);

  return (
    <div>
      <iframe
        style={{
          width: "100%",
          height: "70vh",
          borderRadius: "10px",
        }}
        id="myIframe"
        allow="camera"
        src={paymentUrl}
      />
    </div>
  );
}

export default MudrexURL;
